module.exports = __webpack_public_path__ + "static/media/HBCU.a3916544.jpg";